<template>
  <div class="dont-worry-usps bg-women-shade rounded p-3">
    <div class="max-w-51rem mx-auto">
      <p v-if="title" class="o-body font-bold mb-rem" v-text="title" />
      <div>
        <div
          v-for="usp in usps"
          :key="usp"
          class="flex mb-rem items-center"
        >
          <span>
            <OSvg svg="checkmark" class="w-4 mr-2 fill-green-400" />
          </span>
          <span class="o-body" v-text="usp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'DontWorryUSPS',
  components: { OSvg },
  props: {
    title: {
      type: String,
      default: ''
    },
    usps: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style lang="postcss" scoped>
.max-w-51rem {
  max-width: 51rem;
}
</style>
